/**
 * Dildong — Widget de Chat Lúa
 * Versión 1.1 — Tema blanco con naranja Dildong #E8961C
 *
 * INSTALACIÓN EN SHOPIFY:
 * 1. Online Store → Themes → Edit code → Assets → Add asset
 * 2. Sube este archivo como "dildong-lua-widget.js"
 * 3. En theme.liquid, antes de </body>:
 *    <script src="{{ 'dildong-lua-widget.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  const WEBHOOK_URL    = 'https://n8n.thsistemas.com.mx/webhook/dildong-chat';
  const ASSISTANT_NAME = 'Lúa';
  const WELCOME_MSG    = '¡Hola! Soy Lúa, tu asesora personal de Dildong. 😊\n\n¿En qué te puedo ayudar hoy?';
  const PLACEHOLDER    = 'Escríbeme aquí...';

  let history   = [];
  let sessionId = 'session_' + Math.random().toString(36).slice(2);
  let isOpen    = false;
  let isTyping  = false;

  const STYLES = `
    #lua-btn {
      position:fixed; bottom:28px; right:28px; z-index:9998;
      width:60px; height:60px; border-radius:50%;
      background:#E8961C; border:none; cursor:pointer;
      box-shadow:0 4px 18px rgba(232,150,28,.45);
      display:flex; align-items:center; justify-content:center;
      transition:transform .25s cubic-bezier(.34,1.56,.64,1), box-shadow .25s ease;
      animation:lua-pulse 3.5s ease-in-out infinite;
    }
    #lua-btn:hover { transform:scale(1.1); box-shadow:0 6px 26px rgba(232,150,28,.6); }
    #lua-btn svg { transition:transform .3s ease; }
    #lua-btn.open svg { transform:rotate(45deg); }
    @keyframes lua-pulse {
      0%,100% { box-shadow:0 4px 18px rgba(232,150,28,.45),0 0 0 0 rgba(232,150,28,.2); }
      50%      { box-shadow:0 4px 22px rgba(232,150,28,.55),0 0 0 9px rgba(232,150,28,.04); }
    }

    #lua-window {
      position:fixed; bottom:100px; right:28px; z-index:9997;
      width:360px; max-width:calc(100vw - 40px);
      height:520px; max-height:calc(100vh - 130px);
      background:#fff; border-radius:20px;
      box-shadow:0 8px 40px rgba(26,20,16,.15),0 2px 8px rgba(232,150,28,.07);
      border:1px solid #E8E0D8;
      display:flex; flex-direction:column; overflow:hidden;
      transform-origin:bottom right;
      transition:transform .3s cubic-bezier(.34,1.56,.64,1), opacity .25s ease;
      transform:scale(0.7) translateY(20px); opacity:0; pointer-events:none;
    }
    #lua-window.open { transform:scale(1) translateY(0); opacity:1; pointer-events:all; }

    #lua-header {
      background:#E8961C; padding:14px 16px;
      display:flex; align-items:center; gap:10px; flex-shrink:0;
    }
    #lua-avatar {
      width:38px; height:38px; border-radius:50%;
      background:rgba(255,255,255,.22); border:2px solid rgba(255,255,255,.45);
      display:flex; align-items:center; justify-content:center;
      font-family:Georgia,serif; font-size:17px; color:#fff; font-style:italic; flex-shrink:0;
    }
    #lua-header-info { flex:1; }
    #lua-header-name {
      font-family:Georgia,serif; font-style:italic;
      font-size:16px; color:#fff; line-height:1.2; font-weight:normal;
    }
    #lua-header-status {
      font-size:11px; color:rgba(255,255,255,.85);
      display:flex; align-items:center; gap:4px;
      font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
    }
    #lua-status-dot { width:6px; height:6px; border-radius:50%; background:#fff; opacity:.9; display:inline-block; }
    #lua-close {
      background:rgba(255,255,255,.18); border:none; color:#fff; cursor:pointer;
      padding:5px; border-radius:8px; transition:background .2s; display:flex; align-items:center;
    }
    #lua-close:hover { background:rgba(255,255,255,.32); }

    #lua-messages {
      flex:1; overflow-y:auto; padding:14px 12px;
      display:flex; flex-direction:column; gap:10px;
      background:#F8F4F0;
      scrollbar-width:thin; scrollbar-color:#D8CCBF transparent;
    }
    #lua-messages::-webkit-scrollbar { width:4px; }
    #lua-messages::-webkit-scrollbar-thumb { background:#D8CCBF; border-radius:2px; }

    .lua-msg { display:flex; gap:8px; align-items:flex-end; animation:lua-slide-in .25s ease-out; }
    @keyframes lua-slide-in { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
    .lua-msg.user { flex-direction:row-reverse; }

    .lua-bubble {
      max-width:82%; padding:10px 13px; border-radius:16px;
      font-size:13.5px; line-height:1.55; white-space:pre-wrap; word-break:break-word;
      font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
    }
    .lua-msg.assistant .lua-bubble {
      background:#fff; color:#1A1410;
      border:1px solid #E8E0D8; border-bottom-left-radius:4px;
      box-shadow:0 1px 4px rgba(26,20,16,.05);
    }
    .lua-msg.user .lua-bubble {
      background:#E8961C; color:#fff;
      border-bottom-right-radius:4px;
      box-shadow:0 1px 6px rgba(232,150,28,.28);
    }

    .lua-mini-avatar {
      width:26px; height:26px; border-radius:50%; background:#E8961C;
      display:flex; align-items:center; justify-content:center;
      font-family:Georgia,serif; font-style:italic; font-size:11px; color:#fff; flex-shrink:0;
    }
    .lua-msg.user .lua-mini-avatar { display:none; }

    .lua-bubble a { color:#C87810; text-decoration:none; border-bottom:1px solid rgba(200,120,16,.3); transition:border-color .2s; }
    .lua-bubble a:hover { border-color:#C87810; }
    .lua-msg.user .lua-bubble a { color:rgba(255,255,255,.9); border-color:rgba(255,255,255,.4); }
    .lua-bubble strong { color:#C87810; }
    .lua-msg.user .lua-bubble strong { color:#fff; font-weight:600; }

    #lua-typing { display:flex; gap:8px; align-items:flex-end; padding:0 12px 4px; }
    .lua-dots {
      background:#fff; border:1px solid #E8E0D8; border-radius:16px; border-bottom-left-radius:4px;
      padding:10px 14px; display:flex; gap:4px; align-items:center;
      box-shadow:0 1px 4px rgba(26,20,16,.05);
    }
    .lua-dot { width:6px; height:6px; border-radius:50%; background:#C8A880; animation:lua-bounce .9s ease-in-out infinite; }
    .lua-dot:nth-child(2) { animation-delay:.15s; }
    .lua-dot:nth-child(3) { animation-delay:.3s; }
    @keyframes lua-bounce { 0%,60%,100%{transform:translateY(0);opacity:.5} 30%{transform:translateY(-5px);opacity:1} }

    #lua-input-area {
      border-top:1px solid #E8E0D8; background:#fff;
      padding:10px 12px; display:flex; gap:8px; align-items:flex-end; flex-shrink:0;
    }
    #lua-input {
      flex:1; background:#F8F4F0; border:1px solid #E8E0D8; border-radius:12px;
      padding:9px 13px; color:#1A1410; font-size:13.5px; line-height:1.4;
      resize:none; min-height:38px; max-height:100px; outline:none;
      font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
      transition:border-color .2s, background .2s;
    }
    #lua-input::placeholder { color:#A89880; }
    #lua-input:focus { border-color:rgba(232,150,28,.5); background:#fff; }

    #lua-send {
      width:38px; height:38px; border-radius:50%; background:#E8961C;
      border:none; cursor:pointer; display:flex; align-items:center; justify-content:center;
      flex-shrink:0; transition:transform .2s ease, opacity .2s, background .2s;
      box-shadow:0 2px 8px rgba(232,150,28,.35);
    }
    #lua-send:hover { background:#C87810; transform:scale(1.08); }
    #lua-send:disabled { opacity:.4; cursor:default; transform:none; }

    #lua-footer {
      text-align:center; font-size:10.5px; color:#A89880;
      padding:5px 12px 8px; background:#fff;
      border-top:1px solid #F0EAE2;
      font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
    }
    #lua-footer a { color:#E8961C; text-decoration:none; font-weight:500; }
    #lua-footer a:hover { text-decoration:underline; }

    @media (max-width:480px) {
      #lua-window {
        top:0 !important; left:0 !important; right:0 !important; bottom:0 !important;
        width:100% !important; max-width:100% !important;
        height:100% !important; max-height:100% !important;
        border-radius:0 !important; border:none !important;
        transform-origin:bottom center !important;
      }
      #lua-window.open { transform:scale(1) translateY(0) !important; }
      #lua-header { padding:env(safe-area-inset-top, 14px) 16px 14px; }
      #lua-messages { flex:1; }
      #lua-input-area { padding-bottom:env(safe-area-inset-bottom, 10px); }
      #lua-btn { bottom:20px; right:20px; }
      #lua-btn.open { display:none !important; }
      #lua-send { width:44px; height:44px; }
    }
  `;

  function escapeHtml(s) {
    return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function formatMessage(text) {
    let h = escapeHtml(text);
    h = h.replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>');
    h = h.replace(/(https?:\/\/[^\s<]+)/g,'<a href="$1" target="_blank" rel="noopener">$1</a>');
    h = h.replace(/\n/g,'<br>');
    return h;
  }

  function buildWidget() {
    const s = document.createElement('style');
    s.id = 'lua-styles'; s.textContent = STYLES;
    document.head.appendChild(s);

    const btn = document.createElement('button');
    btn.id = 'lua-btn';
    btn.setAttribute('aria-label','Abrir chat con Lúa de Dildong');
    btn.innerHTML = `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`;

    const win = document.createElement('div');
    win.id = 'lua-window';
    win.setAttribute('role','dialog');
    win.innerHTML = `
      <div id="lua-header">
        <div id="lua-avatar">L</div>
        <div id="lua-header-info">
          <div id="lua-header-name">${ASSISTANT_NAME}</div>
          <div id="lua-header-status"><span id="lua-status-dot"></span> Asesora personal · En línea</div>
        </div>
        <button id="lua-close" aria-label="Cerrar">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div id="lua-messages" aria-live="polite"></div>
      <div id="lua-typing" style="display:none">
        <div class="lua-mini-avatar">L</div>
        <div class="lua-dots"><div class="lua-dot"></div><div class="lua-dot"></div><div class="lua-dot"></div></div>
      </div>
      <div id="lua-input-area">
        <textarea id="lua-input" rows="1" placeholder="${PLACEHOLDER}" maxlength="500" aria-label="Escribe tu mensaje"></textarea>
        <button id="lua-send" aria-label="Enviar">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
          </svg>
        </button>
      </div>
      <div id="lua-footer">Asesora de <a href="https://dildong.mx" target="_blank">Dildong</a> · Todo es confidencial</div>
    `;
    document.body.appendChild(btn);
    document.body.appendChild(win);
    return { btn, win };
  }

  function addMessage(role, text) {
    const c = document.getElementById('lua-messages');
    const d = document.createElement('div');
    d.className = 'lua-msg ' + role;
    d.innerHTML = (role==='assistant' ? `<div class="lua-mini-avatar">L</div>` : '')
                + `<div class="lua-bubble">${formatMessage(text)}</div>`;
    c.appendChild(d);
    c.scrollTop = c.scrollHeight;
  }

  function setTyping(show) {
    isTyping = show;
    document.getElementById('lua-typing').style.display = show ? 'flex' : 'none';
    if (show) document.getElementById('lua-messages').scrollTop = 99999;
  }
  function setSendDisabled(v) {
    document.getElementById('lua-send').disabled = v;
    document.getElementById('lua-input').disabled = v;
  }

  async function sendMessage(text) {
    if (!text.trim() || isTyping) return;
    addMessage('user', text);
    setTyping(true); setSendDisabled(true);
    try {
      const res = await fetch(WEBHOOK_URL, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ message: text, session_id: sessionId, history })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      setTyping(false);
      addMessage('assistant', data.response);
      if (data.updated_history) history = data.updated_history;
    } catch(e) {
      console.error('[Lúa]', e);
      setTyping(false);
      addMessage('assistant', 'Disculpa, tuve un problema de conexión. ¿Puedes intentarlo de nuevo?');
    }
    setSendDisabled(false);
    document.getElementById('lua-input').focus();
  }

  function toggleChat() {
    isOpen = !isOpen;
    document.getElementById('lua-btn').classList.toggle('open', isOpen);
    document.getElementById('lua-window').classList.toggle('open', isOpen);
    if (isOpen) {
      if (document.getElementById('lua-messages').children.length === 0) {
        setTimeout(() => addMessage('assistant', WELCOME_MSG), 200);
      }
      setTimeout(() => document.getElementById('lua-input').focus(), 350);
    }
  }

  function autoResize(el) {
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 100) + 'px';
  }

  function init() {
    const { btn } = buildWidget();
    btn.addEventListener('click', toggleChat);
    document.getElementById('lua-close').addEventListener('click', toggleChat);
    const input = document.getElementById('lua-input');
    const send  = document.getElementById('lua-send');
    send.addEventListener('click', () => {
      const t = input.value.trim();
      if (!t) return;
      input.value = ''; autoResize(input); sendMessage(t);
    });
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send.click(); }
    });
    input.addEventListener('input', () => autoResize(input));
    document.addEventListener('click', e => {
      const w = document.getElementById('lua-window');
      if (isOpen && !w.contains(e.target) && !btn.contains(e.target)) toggleChat();
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
